//Local url
// export const API_URL="http://localhost:8085/";

//UAT url
export const API_URL="https://uatsimoapitmp.altius.cc/";
// export const API_URL="https://uatsimoapitmp.altius.cc/";

//Live url
// export const API_URL="https://simoapi.altius.cc/";

// Dealer signUp Url
//UAT url
export const DEALER_SIGNUP_URL="https://uat-abacus.altius.cc/dealer/dealerSignUp.htm";

//Live url
// export const DEALER_SIGNUP_URL="https://gkdata.co.uk/dealer/dealerSignUp.htm";

//recaptcha data
export const REACT_APP_SITE_KEY = "6LfE-U4qAAAAACvKlvIbY3UIjzfUN4WvK-M7m4C3";
// 
//local url
// export const WEB_URL="http://localhost:3000/";

//UAT url
export const WEB_URL="https://gktsimouat.altius.cc/";

//Live url
// export const WEB_URL="https://iotmobile.co.uk/";

//uat stripe keys
export const STRIPE_PUBLISH_KEY="pk_test_51Rtspt4K1Lo7ADZ61pGGbLpgmV5JVbNkJo0p5W31ZnoVrDFSiBn3vceuRNTu7fmVgZvt4AcPa8Pfw6eVPtEpXb3m00VJAzta4e";

//live stripe keys
//export const STRIPE_PUBLISH_KEY="pk_test_51Rtspt4K1Lo7ADZ61pGGbLpgmV5JVbNkJo0p5W31ZnoVrDFSiBn3vceuRNTu7fmVgZvt4AcPa8Pfw6eVPtEpXb3m00VJAzta4e";